import { TDeliveryMethod } from '../../generated/graphql';
import { useQueryAddressById } from '../addresses/queries';
import { TDependantType } from '../dependants/queries';
import { TEmployeeType } from '../employees/queries';

export type TRecipientType = TEmployeeType | TDependantType;

type TGetRecipientAddressId = {
  deliveryMethod?: TDeliveryMethod;
  companyId: string;
  employeeId: string;
  officeId?: string | null;
};

export const isDependant = (recipient: any): recipient is TDependantType => {
  return (recipient as TDependantType).employeeId != null;
};

export const useGetRecipientAddressId = (props: TGetRecipientAddressId) => {
  const { companyId, officeId, employeeId, deliveryMethod } = props;

  let addressId: string | undefined;
  let address;

  if (deliveryMethod === TDeliveryMethod.Home) addressId = `${import.meta.env.REACT_APP_EMPLOYEES_TABLE_NAME}|${employeeId}`;
  else if (deliveryMethod === TDeliveryMethod.Office) addressId = officeId ? `${import.meta.env.REACT_APP_OFFICES_TABLE_NAME}|${officeId}` : `${import.meta.env.REACT_APP_COMPANIES_TABLE_NAME}|${companyId}`;
  else if (deliveryMethod === TDeliveryMethod.Hybrid) addressId = officeId ? `${import.meta.env.REACT_APP_OFFICES_TABLE_NAME}|${officeId}` : `${import.meta.env.REACT_APP_EMPLOYEES_TABLE_NAME}|${employeeId}`;

  address = useQueryAddressById(addressId as string);

  if (!address.data) addressId = `${import.meta.env.REACT_APP_COMPANIES_TABLE_NAME}|${companyId}`;

  address = useQueryAddressById(addressId as string);

  if (!address.data) addressId = undefined;

  return addressId;
};
